import { CSSProperties } from "react";

const queryBuilderReactFlowBgImage = () => {
  const positions = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  const circles = positions
    .flatMap((y) =>
      positions.map(
        (x) =>
          `<circle cx="${x}" cy="${y}" r="0.5" fill="#999999" fill-opacity="0.8"/>`
      )
    )
    .join("");

  return `data:image/svg+xml,${encodeURIComponent(`
            <svg width="102" height="102" viewBox="0 0 102 102" xmlns="http://www.w3.org/2000/svg">
                <rect width="102" height="102" fill="#F2F2F2"/>
                <path transform="translate(47,47)" d="M2.59511 5.99527V0H3.40489V5.99527H2.59511ZM0 3.40016V2.59511H6V3.40016H0Z" fill="#666666" fill-opacity="0.7"/>
                ${circles}
            </svg>
        `)}`;
};

export const queryBuilderReacFlowBackground: CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: -1,
  backgroundColor: "#F2F2F2",
  backgroundImage: `url("${queryBuilderReactFlowBgImage()}")`,
  backgroundRepeat: "repeat",
  backgroundSize: "55px 55px",
  borderRadius: "20px",
};

export const customReactFlowBackgroundStyle = (
  zoom: number = 1, 
  x: number = 0, 
  y: number = 0
) => {
  const gridSize = 80;
  const scaledGridSize = gridSize * zoom;

  // Calculate offset to maintain grid alignment with panning
  const xOffset = x % scaledGridSize;
  const yOffset = y % scaledGridSize;

  return {
    height: '100%',
    width: '100%',
    backgroundColor: "#F2F2F2",
    backgroundImage: `url("${queryBuilderReactFlowBgImage()}")`,
    backgroundSize: `${scaledGridSize}px ${scaledGridSize}px`,
    backgroundPosition: `${xOffset}px ${yOffset}px`,
    backgroundRepeat: "repeat",
    transition: "background-position 0s linear", // Remove transition for smoother panning
    borderRadius: "20px",
  };
};
